export default "__VITE_ASSET__Ct$xEpIe__"